import { render, staticRenderFns } from "./AnonymisationConfiguration.vue?vue&type=template&id=2c07796f&"
import script from "./AnonymisationConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AnonymisationConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports